import { render, staticRenderFns } from "./CommentsApp.vue?vue&type=template&id=49967e31&"
import script from "./CommentsApp.vue?vue&type=script&lang=js&"
export * from "./CommentsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports